import { z } from 'zod';
import { stringArraySchema, timestampSchema } from './shared';

export const serviceRowSchema = z.object({
  slug: z.string().min(1),
  iconName: z.string().min(1),
  title: z.string().min(1),
  description: z.string(),
  positioningStatement: z.string().nullable(),
  image: z.string().nullable(),
  deliverables: stringArraySchema.nullable(),
  bestFor: z.string().nullable(),
  sortOrder: z.number().int(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const serviceInsertSchema = z.object({
  slug: z.string().min(1),
  iconName: z.string().min(1),
  title: z.string().min(1),
  description: z.string(),
  positioningStatement: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  deliverables: stringArraySchema.nullable().optional(),
  bestFor: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
});

export const serviceUpdateSchema = serviceInsertSchema.partial();

export type ServiceRow = z.infer<typeof serviceRowSchema>;
export type ServiceInsert = z.input<typeof serviceInsertSchema>;
export type ServiceUpdate = z.input<typeof serviceUpdateSchema>;
